'use es6';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { useFullstory } from 'data-ops-fullstory';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';

// Redux
import { Provider } from 'react-redux';

// Router
import { withRouter } from 'react-router-dom';

// Store set up
import configureStore from 'reports-list-components/utils/configureStore';
import { fetchDashboardWidgetCounts } from 'reports-list-components/actions/dashboard-widget-count';
import { getReportCounts, getFilteredReportCount } from 'reports-list-components/actions/reportsActions';
import { getOwners } from 'reports-list-components/actions/ownersActions';
import { getDashboards } from 'reports-list-components/actions/dashboardsActions';
import { fetchFavorites } from './redux/favorites';
import { fetchDashboardSentenceMulti } from 'dashboard-lib/public/permission/permission-action';
import { getAIAccessSettings } from 'reports-list-components/actions/aiSettingsActions';
import ReportingActionsLoader from 'reporting-action-components/reportingActions/ReportingActionsLoader';
import { REPORT_ACTION_DIALOGS } from 'reporting-action-components/dialog/dialogSets';
import { SINGLE_REPORT_VIEWER } from 'reporting-action-components/dialog/dialogTypes';
import { fetchFavorites as fetchUnifiedFavorites } from './SmartLibrary/redux/favoritesReducer';
import { ShareToSlackPanelLoader } from 'slack-ui-library';
import EventTrackerWrapper from './containers/EventTrackerWrapper';
import { initializeUserInfo } from 'dashboard-lib/public/userInfo';
import ReportViewerModal from './components/ReportViewerModal';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import Routes from './Routes';
import { fetchTags } from './redux/tags';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportsListComponent = ({
  history,
  userInfo
}) => {
  const [isStoreConfigured, setIsStoreConfigured] = useState(false);
  const [store, setStore] = useState(null);
  useFullstory({
    appKey: 'ReportsList',
    useFreeSessionChaining: true
  });
  /*eslint-disable  react-hooks/exhaustive-deps*/
  useEffect(() => {
    const {
      gates,
      user,
      portal
    } = userInfo;
    const reduxStore = configureStore({
      auth: {
        user,
        gates,
        portal
      }
    }, history);
    setDocumentTitle('reports.header.title');
    reduxStore.dispatch(initializeUserInfo(userInfo));
    reduxStore.dispatch(fetchDashboardSentenceMulti({
      userId: user.user_id
    }));
    reduxStore.dispatch(getDashboards());
    reduxStore.dispatch(fetchFavorites());
    reduxStore.dispatch(getReportCounts());
    reduxStore.dispatch(getFilteredReportCount());
    reduxStore.dispatch(getOwners());
    reduxStore.dispatch(fetchDashboardWidgetCounts());
    reduxStore.dispatch(fetchUnifiedFavorites());
    reduxStore.dispatch(fetchTags());
    setStore(reduxStore);
    setIsStoreConfigured(true);
  }, []);
  useEffect(() => {
    if (isStoreConfigured) {
      store.dispatch(getAIAccessSettings());
    }
  }, [isStoreConfigured, store]);
  return !isStoreConfigured ? /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "md",
    minHeight: "100vh"
  }) : /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(CopilotProvider, {
      children: /*#__PURE__*/_jsx(ReportingActionsLoader, {
        additionalDialogs: Object.assign({}, REPORT_ACTION_DIALOGS, {
          [SINGLE_REPORT_VIEWER]: ReportViewerModal
        }),
        children: /*#__PURE__*/_jsx(ShareToSlackPanelLoader, {
          children: /*#__PURE__*/_jsx(EventTrackerWrapper, {
            children: /*#__PURE__*/_jsx(Routes, {})
          })
        })
      })
    })
  });
};
ReportsListComponent.propTypes = {
  history: PropTypes.object.isRequired,
  userInfo: PropTypes.shape({
    gates: PropTypes.array.isRequired,
    portal: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  })
};
export default withRouter(ReportsListComponent);